module.exports = __webpack_public_path__ + "img/VT.e57f2e23.png";